var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.containerClass,style:({
    background: _vm.containerColor,
    zIndex: _vm.zIndex
  })},[_c('div',{class:_vm.barClass,style:({
      width: (_vm.width + "%"),
      height: _vm.height,
      background: _vm.backgroundColor
    })})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a1d133c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@guillaumebriday/vue-scroll-progress-bar/src/components/VueScrollProgressBar.vue
// module id = 76
// module chunks = 0